"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));
var _LabelHeader = _interopRequireDefault(require("../Navigation/components/LabelHeader"));
var _ProTip = _interopRequireDefault(require("./ProTip"));
var _excluded = ["hasConnectedAccounts", "activeAccount", "className", "onClick", "showProTip"];
var AccountDrawer = function AccountDrawer(_ref) {
  var isOpen = _ref.isOpen,
    activeAccount = _ref.activeAccount,
    showProTip = _ref.showProTip,
    onToggle = _ref.onToggle,
    children = _ref.children,
    _ref$hasConnectedAcco = _ref.hasConnectedAccounts,
    hasConnectedAccounts = _ref$hasConnectedAcco === void 0 ? false : _ref$hasConnectedAcco;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(AccountSwitch, {
    hasConnectedAccounts: hasConnectedAccounts,
    activeAccount: activeAccount,
    onClick: onToggle,
    showProTip: showProTip
  }), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    anchor: "left",
    open: isOpen,
    onClose: onToggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full bg-app p-6",
    style: {
      width: 350
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-1"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-bold text-2xl mb-1"
  }, t('retrofit.accounts.header')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light text-xs font-light"
  }, t('retrofit.accounts.description'))), children)));
};
var AccountSwitch = function AccountSwitch(_ref2) {
  var _ref2$hasConnectedAcc = _ref2.hasConnectedAccounts,
    hasConnectedAccounts = _ref2$hasConnectedAcc === void 0 ? false : _ref2$hasConnectedAcc,
    activeAccount = _ref2.activeAccount,
    className = _ref2.className,
    onClick = _ref2.onClick,
    showProTip = _ref2.showProTip,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    onClick: onClick,
    className: (0, _classnames["default"])(className, 'w-full py-2 px-6 cursor-pointer select-none', {
      'hover:bg-secondary bg-card': !activeAccount,
      'bg-primary': activeAccount
    })
  }), /*#__PURE__*/_react["default"].createElement(_LabelHeader["default"], {
    actions: /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('rounded-full text-center flex-shrink-0 flex items-center justify-center w-5 h-5', {
        'bg-light text-white opacity-75': !activeAccount,
        'bg-white text-primary': activeAccount
      })
    }, /*#__PURE__*/_react["default"].createElement(_FilterList["default"], {
      fontSize: "inherit"
    }))
  }, /*#__PURE__*/_react["default"].createElement(_ProTip["default"], {
    open: showProTip
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('truncate pr-4', {
      'text-white': !!activeAccount
    })
  }, activeAccount ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold normal-case"
  }, activeAccount) : t('retrofit.accounts.drawer.title', {
    count: hasConnectedAccounts ? 2 : 1
  })))));
};
var _default = exports["default"] = AccountDrawer;
//# sourceMappingURL=AccountDrawer.js.map